// extracted by mini-css-extract-plugin
module.exports = {"btn-outlined":"button-outlined_btn-outlined__2CepR"};